import { render, staticRenderFns } from "./cruisesBookings.vue?vue&type=template&id=0a1ebf77"
import script from "./cruisesBookings.vue?vue&type=script&lang=js"
export * from "./cruisesBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports